var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebChatSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 63,
    viewBox: "0 0 80 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1_495)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 63,
    fill: "#4B4AD5",
    fillOpacity: 0.1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.47 24.83L45.86 27.99C45.96 28.82 45.07 29.4 44.36 28.97L40.9 26.91C40.66 26.77 40.6 26.47 40.73 26.23C41.23 25.31 41.5 24.27 41.5 23.23C41.5 19.57 38.36 16.59 34.5 16.59C33.71 16.59 32.94 16.71 32.22 16.95C31.85 17.07 31.49 16.73 31.58 16.35C32.49 12.71 35.99 10 40.17 10C45.05 10 49 13.69 49 18.24C49 20.94 47.61 23.33 45.47 24.83Z",
    fill: "#4B4AD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 23.23C40 24.42 39.56 25.52 38.82 26.39C37.83 27.59 36.26 28.36 34.5 28.36L31.89 29.91C31.45 30.18 30.89 29.81 30.95 29.3L31.2 27.33C29.86 26.4 29 24.91 29 23.23C29 21.47 29.94 19.92 31.38 19C32.27 18.42 33.34 18.09 34.5 18.09C37.54 18.09 40 20.39 40 23.23Z",
    fill: "#4B4AD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4552 45.8C24.4552 44.976 24.6392 44.24 25.0072 43.592C25.3832 42.936 25.8912 42.428 26.5312 42.068C27.1792 41.7 27.9032 41.516 28.7032 41.516C29.6392 41.516 30.4592 41.756 31.1632 42.236C31.8672 42.716 32.3592 43.38 32.6392 44.228H30.7072C30.5152 43.828 30.2432 43.528 29.8912 43.328C29.5472 43.128 29.1472 43.028 28.6912 43.028C28.2032 43.028 27.7672 43.144 27.3832 43.376C27.0072 43.6 26.7112 43.92 26.4952 44.336C26.2872 44.752 26.1832 45.24 26.1832 45.8C26.1832 46.352 26.2872 46.84 26.4952 47.264C26.7112 47.68 27.0072 48.004 27.3832 48.236C27.7672 48.46 28.2032 48.572 28.6912 48.572C29.1472 48.572 29.5472 48.472 29.8912 48.272C30.2432 48.064 30.5152 47.76 30.7072 47.36H32.6392C32.3592 48.216 31.8672 48.884 31.1632 49.364C30.4672 49.836 29.6472 50.072 28.7032 50.072C27.9032 50.072 27.1792 49.892 26.5312 49.532C25.8912 49.164 25.3832 48.656 25.0072 48.008C24.6392 47.36 24.4552 46.624 24.4552 45.8ZM37.8181 43.256C38.3221 43.256 38.7701 43.368 39.1621 43.592C39.5541 43.808 39.8581 44.132 40.0741 44.564C40.2981 44.988 40.4101 45.5 40.4101 46.1V50H38.7301V46.328C38.7301 45.8 38.5981 45.396 38.3341 45.116C38.0701 44.828 37.7101 44.684 37.2541 44.684C36.7901 44.684 36.4221 44.828 36.1501 45.116C35.8861 45.396 35.7541 45.8 35.7541 46.328V50H34.0741V41.12H35.7541V44.18C35.9701 43.892 36.2581 43.668 36.6181 43.508C36.9781 43.34 37.3781 43.256 37.8181 43.256ZM41.5757 46.652C41.5757 45.98 41.7077 45.384 41.9717 44.864C42.2437 44.344 42.6077 43.944 43.0637 43.664C43.5277 43.384 44.0437 43.244 44.6117 43.244C45.1077 43.244 45.5397 43.344 45.9077 43.544C46.2837 43.744 46.5837 43.996 46.8077 44.3V43.352H48.4997V50H46.8077V49.028C46.5917 49.34 46.2917 49.6 45.9077 49.808C45.5317 50.008 45.0957 50.108 44.5997 50.108C44.0397 50.108 43.5277 49.964 43.0637 49.676C42.6077 49.388 42.2437 48.984 41.9717 48.464C41.7077 47.936 41.5757 47.332 41.5757 46.652ZM46.8077 46.676C46.8077 46.268 46.7277 45.92 46.5677 45.632C46.4077 45.336 46.1917 45.112 45.9197 44.96C45.6477 44.8 45.3557 44.72 45.0437 44.72C44.7317 44.72 44.4437 44.796 44.1797 44.948C43.9157 45.1 43.6997 45.324 43.5317 45.62C43.3717 45.908 43.2917 46.252 43.2917 46.652C43.2917 47.052 43.3717 47.404 43.5317 47.708C43.6997 48.004 43.9157 48.232 44.1797 48.392C44.4517 48.552 44.7397 48.632 45.0437 48.632C45.3557 48.632 45.6477 48.556 45.9197 48.404C46.1917 48.244 46.4077 48.02 46.5677 47.732C46.7277 47.436 46.8077 47.084 46.8077 46.676ZM52.0965 44.732V47.948C52.0965 48.172 52.1485 48.336 52.2525 48.44C52.3645 48.536 52.5485 48.584 52.8045 48.584H53.5845V50H52.5285C51.1125 50 50.4045 49.312 50.4045 47.936V44.732H49.6125V43.352H50.4045V41.708H52.0965V43.352H53.5845V44.732H52.0965Z",
    fill: "#4B4AD5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C1.65685 0 3 1.34315 3 3V60C3 61.6569 1.65685 63 0 63V0Z",
    fill: "#4B4AD5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1_495",
    x: 0,
    y: 0,
    width: 80,
    height: 63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.886275 0 0 0 0 0.886275 0 0 0 0 0.917647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_495"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebChatSelected);
export default __webpack_public_path__ + "static/media/web_chat_selected.dd3580ed1dd5303286ab4faf7d33625a.svg";
export { ForwardRef as ReactComponent };